<div class="boton_terciario">
    <button [disabled]="disabled" class="button_terciario" [ngClass]="{'button_terciario-diff1':disabled}"
        (click)="ejecutarFuncion()">
        <p class="texto_boton_terciario" [ngClass]="{'texto_boton_terciario-diff1':disabled}">{{boton_texto}}</p>
    </button>
</div>